<template>
  <el-dialog
    title="New Note"
    :visible.sync="isVisible"
    :close-on-click-modal="!isCreatingNote"
    :close-on-press-escape="!isCreatingNote"
    :show-close="!isCreatingNote"
    @closed="$emit('destroy')"
  >
    <NoteCreateForm
      :note="note"
    />

    <template #footer>
      <el-button
        :disabled="isCreatingNote"
        @click.native="isVisible = false"
      >
        Cancel
      </el-button>

      <el-button
        type="primary"
        :loading="isCreatingNote"
        @click.native="createNote"
      >
        Add Note
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import NoteCreateForm from '@/components/Notes/Note/CreateForm'

export default {
  components: {
    NoteCreateForm
  },
  props: {
    note: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isVisible: true,
      isCreatingNote: false
    }
  },
  methods: {
    async createNote () {
      this.isCreatingNote = true

      try {
        await this.note.create()

        this.$message.success('Successfully created Note')
        this.$emit('created-note', this.note)

        this.isVisible = false
      } catch {
        this.$message.error('Failed to create new Note')
      }

      this.isCreatingNote = false
    }
  }
}
</script>
